import React from 'react';
import { ParkingType } from '../types/parking';
import { getIconByColorAndType } from '../utils/iconMapping';

interface TypeLegendProps {
  parkingTypes: ParkingType[];
  iconType?: 'parking' | 'bicycle' | 'locker';
}

const TypeLegend: React.FC<TypeLegendProps> = ({ parkingTypes, iconType = 'parking' }) => {
  if (!parkingTypes || parkingTypes.length === 0) {
    return null;
  }

  // Helper to get image path (try standardImage first, fallback to color-based mapping)
  const getImagePath = (type: ParkingType, isSelected: boolean): string => {
    if (isSelected && type.selectedImage) {
      return type.selectedImage;
    }
    if (!isSelected && type.standardImage) {
      return type.standardImage;
    }

    // Fallback to color-based mapping
    const color = isSelected ? (type.selectedColor || '#2196F3') : (type.standardColor || '#4CAF50');
    return getIconByColorAndType(color, iconType) || '';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '12px'
    }}>
      {parkingTypes.map((type) => {
        const standardImagePath = getImagePath(type, false);
        const selectedImagePath = getImagePath(type, true);

        return (
          <React.Fragment key={type._id}>
            {/* Standard variant */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {standardImagePath ? (
                <img
                  src={standardImagePath}
                  alt={`${type.name} Standard`}
                  style={{
                    width: '32px',
                    height: '20px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    border: '1px solid #D1D5DB',
                    flexShrink: 0,
                    background: '#F9FAFB',
                    padding: '2px'
                  }}
                />
              ) : (
                <div style={{
                  width: '32px',
                  height: '20px',
                  backgroundColor: type.standardColor || '#4CAF50',
                  borderRadius: '4px',
                  border: '1px solid #D1D5DB',
                  flexShrink: 0
                }} />
              )}
              <span style={{ fontSize: '13px', color: '#374151' }}>
                {type.name} (Standard)
              </span>
            </div>

            {/* Selected/Premium variant */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              {selectedImagePath ? (
                <img
                  src={selectedImagePath}
                  alt={`${type.name} Selected`}
                  style={{
                    width: '32px',
                    height: '20px',
                    objectFit: 'contain',
                    borderRadius: '4px',
                    border: '1px solid #D1D5DB',
                    flexShrink: 0,
                    background: '#F9FAFB',
                    padding: '2px'
                  }}
                />
              ) : (
                <div style={{
                  width: '32px',
                  height: '20px',
                  backgroundColor: type.selectedColor || '#2196F3',
                  borderRadius: '4px',
                  border: '1px solid #D1D5DB',
                  flexShrink: 0
                }} />
              )}
              <span style={{ fontSize: '13px', color: '#374151' }}>
                {type.name} (Selected)
              </span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TypeLegend;
